import { useEffect } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'

import AppLayout from '@/components/layout/AppLayout'
import RequireAuth from '@/components/layout/RequireAuth'
import CalendarPage from '@/features/calendar/CalendarPage'
import CashReceiptsPage from '@/features/cashreceipts/CashReceiptsPage'
import ChangelogPage from '@/features/changelog/ChangelogPage'
import ClientDetailPage from '@/features/clients/ClientDetailPage'
import ClientsPage from '@/features/clients/ClientsPage'
import EmailsPage from '@/features/emails/EmailsPage'
import HelpPage from '@/features/help/HelpPage'
import InstructorRewardsPage from '@/features/rewards/InstructorRewardsPage'
import InstructorsPage from '@/features/instructors/InstructorsPage'
import InstructorPortalPage from '@/features/portal/InstructorPortalPage'
import LoginPage from '@/features/auth/LoginPage'
import ForgotPasswordPage from '@/features/auth/ForgotPasswordPage'
import PaymentsPage from '@/features/payments/PaymentsPage'
import ReservationsPage from '@/features/reservations/ReservationsPage'
import ResetPasswordPage from '@/features/auth/ResetPasswordPage'
import RewardsPage from '@/features/rewards/RewardsPage'
import SettingsPage from '@/features/settings/SettingsPage'
import StatisticsPage from '@/features/statistics/StatisticsPage'
import SuspendedScreen from '@/features/billing/SuspendedScreen'
import { useAuth } from '@/store/auth'

export default function App() {
  const bootstrap = useAuth((s) => s.bootstrap)
  const status = useAuth((s) => s.status)

  useEffect(() => {
    if (status === 'idle') void bootstrap()
  }, [status, bootstrap])

  return (
    <>
    <SuspendedScreen />
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      {/* Mobilný pohľad inštruktora - tajný odkaz, bez prihlásenia. */}
      <Route path="/i/:token" element={<InstructorPortalPage />} />

      <Route
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/calendar" replace />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/clients/:id" element={<ClientDetailPage />} />
        {/* Nie `/clients/reservations` - to by sadlo na `/clients/:id` a detail
            klienta by dostal „reservations“ namiesto čísla. */}
        <Route path="/reservations" element={<ReservationsPage />} />
        <Route path="/payments" element={<PaymentsPage />} />
        <Route path="/instructors" element={<InstructorsPage />} />
        {/* Odučené hodiny sú teraz filtrom „Rátať: len odučené“ v odmenách. */}
        <Route path="/instructors/units" element={<Navigate to="/rewards?taught=1" replace />} />
        <Route path="/rewards" element={<RewardsPage />} />
        <Route path="/rewards/:id" element={<InstructorRewardsPage />} />
        <Route path="/statistics" element={<StatisticsPage />} />
        <Route path="/cash-receipts" element={<CashReceiptsPage />} />
        <Route path="/changelog" element={<ChangelogPage />} />
        <Route path="/emails" element={<EmailsPage />} />
        <Route path="/settings/*" element={<SettingsPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/help/:topic" element={<HelpPage />} />
      </Route>

      <Route path="*" element={<Navigate to="/calendar" replace />} />
    </Routes>
    </>
  )
}
